(function () {
  var d = document;
  var id = "calconic_";
  if (d.getElementById(id)) return;

  var j = d.createElement("script");
  j.id = id;
  j.type = "text/javascript";
  j.async = true;
  j.dataset.calconic = "true";
  j.src = "https://cdn.calconic.com/static/js/calconic.min.js";

  var first = d.getElementsByTagName("script")[0];
  first.parentNode.insertBefore(j, first);
})();